var React = require('react');

function ExpandUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.999 15l-.002-.002m0 0L24 15l-.002-.002zm2.124-2.119l-.002-.002a2.998 2.998 0 00-4.24.003L.438 34.317a1.5 1.5 0 102.122 2.121L24 15l21.438 21.438a1.5 1.5 0 102.122-2.121L26.12 12.879z"}));
}

ExpandUp.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExpandUp;

ExpandUp.default = ExpandUp;
